import { Alert } from "react-bootstrap";

const AlertSelectionRequired = ({ show }: { show: boolean }) => (
  <Alert show={show} variant="required" className="mw--635 mx-auto pt-0">
    <i className="fal fa-exclamation-circle alert__icon" />
    <div className="alert__text">You must make a selection</div>
  </Alert>
);

export default AlertSelectionRequired;
